import React from 'react'
import EditInvStyle from './EditInvOpportunities.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteConformation from '../DeleteConformation/DeleteConformation';
import useToast from '../../hooks/useToast';
import useBackdrop from '../../hooks/useBackdrop/useBackdrop';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};
// import this for redux read write
const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 18,
    p: 4,
};


const EditInvOpportunities = () => {
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const [open, setOpen] = React.useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);
    const navigate = useNavigate();
    const [checked, setChecked] = React.useState(true);
    const { invId } = useParams();
    const [data, setData] = useState([])
    const [channel, setChannel] = useState('')
    const [channelResponse, setChannelResponse] = React.useState("");
    const { state } = useLocation();
    const [tempData, setTempData] = useState(null);
    const { Toast, showToast } = useToast();
    const { openBackdrop, closeBackdrop, BackdropComponent } = useBackdrop();

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };


    const handleChannelSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSINV}/investmentOpportunities/getInvestmentOpportunitiesById/${invId}`
            )
            // setData(res.data)
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }


    const getHighlightsData = async () => {

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_COSMOSINV}/investmentOpportunities/getInvestmentOpportunitiesById/${invId}`
            )
            setData(res.data)
            console.log(res.data)
        } catch (error) {
            console.log(error)
        }
    }


    const deleteDetailbyId = async () => {
        try {
            const res = await axios.delete(`${process.env.REACT_APP_COSMOSINV}/channel/deleteChannel/${tempData.channelId}`)
                .then((res) => {
                    showToast("success", "Investor Opportunities  Delete Successfully");
                    handleDeleteModal();
                    getHighlightsData();
                })

            dispatch(setNotificationCount({
                count: count + 1,
            }))

        } catch (error) {
            console.log(error)
        }
    }

    const [deleteModal, setDeleteModal] = useState(false);
    const handleDeleteModal = (data) => {
        setDeleteModal(prev => !prev)
        if (data !== undefined && data !== "" && data !== null) {
            setTempData(data)
        }
    }




    const handleClick2 = async (e) => {
        e.preventDefault();

        try {
            const resName = await axios.post(
                `${process.env.REACT_APP_COSMOSINV}/channel/addChannel/${invId}`,
                { channelName: channel, channelType: 'Pitch' },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            handleClose();
            handleClose2();
            getHighlightsData();
            showToast("success", "Add name Successfully");
            //    navigate(`/pitch/${invId}/${ttId}`)           
        } catch (error) {
            console.error(error)
        }
    }


    useEffect(() => {
        getHighlightsData();

    }, [])

    const handleClick = (type) => {
        navigate("/formates", { state: { id: invId, type: type } }, { replace: true })
    }
    const handleClick3 = (type) => {
        navigate("/videofor", { state: { id: invId, type: type } }, { replace: true })
    }


    const [open2, setOpen2] = React.useState(false);
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => setOpen2(false);


    // handlePageChange(highlight.channelType, highlight.channelId, highlight)

    const handlePageChange = (type, channelId, channel) => {

        console.log(channel);
        switch (type) {
            case 'pdf': navigate(`/editpdf/${invId}/${channel.channelId}/${channel.pdf.pdfId}`, { state: { channelData: channel } });
                break;
            case 'Pitch': navigate(`pitch/${channel.channelId}`, {
                state: {
                    channelData: channel,
                    channelName: channel.channelName
                }
            });
                break;
            case 'Video': navigate(`/editVi/${invId}/${channel.channelId}/${channel.file.fileId}`, { state: { channelData: channel } });
                break;
            default: console.log("no type selected");
        }
    }

    return (

        <>
            <Toast />
            <BackdropComponent />
            <div className={EditInvStyle.highlightMain}>
                <div className={EditInvStyle.highlightContent}>
                    <div className={EditInvStyle.highlightHeader}>
                        <div style={{ marginBottom: '2%', display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: '1%' }}>
                            <Typography sx={{ color: '#121926', fontWeight: '600', fontSize: '20px', display: 'flex', alignItems: 'center', gap: '10px' }} >
                                {data.invName}
                                <span onClick={() => { navigate(`/editInvestmentBanner/${invId}`) }}>
                                    <DriveFileRenameOutlineIcon style={{ cursor: 'pointer' }} />
                                </span>
                            </Typography>
                            <Button sx={{ textTransform: 'capitalize', width: '10%' }} variant='contained' onClick={handleOpen}>Add</Button>
                        </div>



                    </div>
                    <Box className={EditInvStyle.highlightComponent}>
                        <div className={EditInvStyle.highlightComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Name
                            </Typography>
                        </div>
                        <div className={EditInvStyle.highlightComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Last modified
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                Action
                            </Typography>
                        </div>
                    </Box>
                    {data.channels?.map((highlight) => {
                        return (
                            <Box className={EditInvStyle.highlightComponent}>
                                <div className={EditInvStyle.highlightComponentLeft}>
                                    <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                        {highlight.channelName}
                                    </Typography>
                                </div>
                                <div className={EditInvStyle.highlightComponentRight}>
                                    <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                        {data.date}
                                    </Typography>
                                    <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>

                                        <span onClick={() => handlePageChange(highlight.channelType, highlight.channelId, highlight)}>
                                            <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                        </span>
                                        <IconButton disableRipple onClick={() => handleDeleteModal(highlight)}>
                                            <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                        </IconButton>
                                    </Typography>
                                </div>
                            </Box>
                        )

                    })}

                </div>
            </div>




            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={{ ...style }} className={EditInvStyle.InvModal}>
                    <div className={EditInvStyle.modalClose}>
                        <Typography variant='h2' >Select type</Typography>
                        <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </div>
                    <Box className={EditInvStyle.InvPermission}>
                        <label>PDF</label>
                        <Button variant="contained" type={"Pdf"} onClick={() => handleClick("pdf")}>Select</Button>

                    </Box>
                    <Box className={EditInvStyle.InvPermission}>
                        <label>Video</label>
                        <Button variant="contained" type={"Video"} onClick={() => handleClick3("Video")}>Select</Button>

                    </Box>
                    <Box className={EditInvStyle.InvPermission}>
                        <label>Pitch</label>
                        {/* <Button variant="contained" type={"Pitch"} onClick={() => handleClick2("Pitch")}>Select</Button> */}
                        <Button variant="contained" type={"Pitch"} onClick={handleOpen2}>Select</Button>
                        <Modal
                            open={open2}
                            onClose={handleClose2}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={style2} className={EditInvStyle.secondfromStart}>
                                <form onSubmit={handleClick2}>
                                    <div className={EditInvStyle.secondfrom}>
                                        <Typography variant='h2'>Add Name</Typography>

                                    </div>
                                    <div className={EditInvStyle.secondfrom}>
                                        <label>Name</label>
                                        <input type='text' autoComplete='off' placeholder='Name' name='channel' value={channel} onChange={(event) => setChannel(event.target.value)} />
                                    </div>
                                    <Button variant="contained" type='submit'>Add</Button>
                                </form>
                            </Box>
                        </Modal>

                    </Box>
                </Box>
            </Modal>

            <DeleteConformation
                onClose={handleDeleteModal}
                open={deleteModal}
                onConfirm={() => deleteDetailbyId()}
                onReject={() => { }}
            >
                <h2>Delete Investor Opportunities</h2>
                <p>Are you sure you want to Delete this Investor Opportunities?</p>

            </DeleteConformation>
        </>
    )
}

export default EditInvOpportunities






